import { DotsColorType, DotsOrientation } from '@app/shared/types/common';
import { cn } from '@app/shared/utils/common';

interface DotProps {
  isCurrent: boolean;
  colorMode?: DotsColorType;
  orientation?: DotsOrientation;
}

export function Dot({ isCurrent, colorMode, orientation }: DotProps) {
  const currentColor = colorMode === 'accent' ? 'bg-accent' : 'bg-white';
  const defaultColor = colorMode === 'accent' ? 'bg-blue-200' : 'bg-white/60';
  const currentSize = orientation === 'horizontal' ? 'w-3' : 'h-3';

  return (
    <span
      className={cn(
        'h-2 w-2 rounded-full transition-all',
        isCurrent ? `${currentSize} ${currentColor}` : defaultColor
      )}
    />
  );
}
